import { useQuery } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';
import { useGetCurrentBoardId, useGetCurrentOrganisationId } from 'hooks';

import { getBoardForms } from '../requests';
import type { GetBoardFormsRequestType } from '../types';

export const useGetBoardForms = (
  queryParams: GetBoardFormsRequestType['queryParams'],
) => {
  const organisationId = useGetCurrentOrganisationId();
  const boardId = useGetCurrentBoardId();

  return useQuery({
    queryKey: [
      API_QUERY_KEYS.boardForms,
      {
        organisationId,
        boardId,
        ...queryParams,
      },
    ],
    queryFn: () =>
      getBoardForms({
        pathParams: {
          organisationId: organisationId.toString(),
          boardId: boardId!.toString(),
        },
        queryParams,
      }),
    keepPreviousData: true,
  });
};
